import React, { ReactNode } from 'react';
import { textTitle3 } from '../../../styles/typography';
import { Headings } from './Headings';
import { classNames } from '../../../utils/style';

export interface HeadingProps {
  title: string;
  subheadings?: Array<{ title: string }>;
}

export interface DetailedTableOfContentProps {
  title?: string;
  children?: ReactNode;
  className?: string;
}

const DetailedTableOfContentComponent = ({
  title,
  children,
  className,
}: DetailedTableOfContentProps) => {
  return (
    <section className={classNames('DetailedTableOfContent py-24', className)}>
      {title && (
        <div
          className={classNames(
            'pb-8 text-24 border-b border-neutral-21',
            textTitle3,
          )}
        >
          {title}
        </div>
      )}
      <div className="">{children}</div>
    </section>
  );
};

export const DetailedTableOfContent = Object.assign(
  DetailedTableOfContentComponent,
  {
    Headings: Headings,
  },
);
